import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import ProjectCard from "./ProjectCards";
import Particle from "../Particle";

import leaf from "../../Assets/Projects/mcfp.png";
import emotion from "../../Assets/Projects/emotion.jpeg";
import editor from "../../Assets/Projects/codeEditor.png";
import nyc from "../../Assets/Projects/nyc.jpeg";
import suicide from "../../Assets/Projects/suicide.png";
import bitsOfCode from "../../Assets/Projects/blog.png";
import bank from "../../Assets/ai-in-banking-and-insurance-use-cases.jpeg";
import etl from "../../Assets/Screen Shot 2023-01-25 at 20.20.59.png";

function Projects() {
  return (
    <Container fluid className="project-section">
      <Particle />
      <Container>
        <h1 className="project-heading">
          My Recent <strong className="purple">Works </strong>
        </h1>
        <p style={{ color: "white" }}>
          Here are a few projects I've worked on recently.
        </p>
        <Row style={{ justifyContent: "center", paddingBottom: "10px" }}>
        <Col md={4} className="project-card">
            <ProjectCard
              imgPath={bank}
              isBlog={false}
              title="Bank Marketing Classification & Clustering"
              description="This project presents a study on the use of ML and DL to predict whether a customer will subscribe to a short-term deposit. I first explored the entire data set to identify the most relevant features for prediction. Then, I used these features to train different machine learning models, including deep neural networks. Finally, I compared the performance of these models to determine which one offers the best prediction results."
              link="https://www.kaggle.com/code/anassbouchfar/classification-clustering"
/>
          </Col>
        <Col md={4} className="project-card">
            <ProjectCard
              imgPath={etl}
              isBlog={false}
              title="ETL Pipelining for the Used Car Prices (TrueCar)"
              description="ETL (Extract Transform and Load) Pipelining for the Used Car Prices using apache airflow and Google BigQuery, also Predictive Modelling with Spark ML Using used Car Attributes"
              link="https://docs.google.com/presentation/d/1lhJ72PvFpXUMwcwXfyhO-ZejUGy5mJ5w/edit?usp=sharing&ouid=106558583290583990934&rtpof=true&sd=true"
/>
          </Col>
          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={nyc}
              isBlog={false}
              title="NYC Traffic Accidents DW"
              description="This is a business intelligence (BI) project consisting of the Building and analysis of a Data Warehouse from a dataset (mavenanalytics.io) of New York City accidents in 2020. I worked on the whole decision-making process from the data extraction phase to the report phase, for that, I used Talend solutions for the ETL phase, MYSQL as DBMS, and POWERBI/DAX for reporting and data visualization."
              link="https://github.com/anassbouchfar/NYC-Traffic-Accidents-DW"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={leaf}
              isBlog={false}
              title="Minimum-cost flow problem (MCFP)"
              //description="Used the plant disease dataset from Kaggle and trained a image classifer model using 'PyTorch' framework using CNN and Transfer Learning with 38 classes of various plant leaves. The model was successfully able to detect diseased and healthy leaves of 14 unique plants. I was able to achieve an accuracy of 98% by using Resnet34 pretrained model."
              description="Project to solve The minimum-cost network flow problem (MCNFP) with FastAPI/Python (Numpy and Scipy ) for problem Resolution  and React JS for User Interface (UI - Frontend) "
              link="https://github.com/anassbouchfar/MCNFP"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={editor}
              isBlog={false}
              title="Editor.io"
              description="Online code and markdown editor build with react.js. Online Editor which supports html, css, and js code with instant view of website. Online markdown editor for building README file which supports GFM, Custom Html tags with toolbar and instant preview.Both the editor supports auto save of work using Local Storage"
              link="https://github.com/soumyajit4419/Editor.io"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={bitsOfCode}
              isBlog={false}
              title="Bits-0f-C0de"
              description="My personal blog page build with Next.js and Tailwind Css which takes the content from makdown files and renders it using Next.js. Supports dark mode and easy to write blogs using markdown."
              link="https://github.com/soumyajit4419/Bits-0f-C0de"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={suicide}
              isBlog={false}
              title="Ai For Social Good"
              description="Using 'Natural Launguage Processing' for the detection of suicide-related posts and user's suicide ideation in cyberspace  and thus helping in sucide prevention."
              link="https://github.com/soumyajit4419/AI_For_Social_Good"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={emotion}
              isBlog={false}
              title="Face Recognition and Emotion Detection"
              description="Trained a CNN classifier using 'FER-2013 dataset' with Keras and tensorflow backened. The classifier sucessfully predicted the various types of emotions of human. And the highest accuracy obtained with the model was 60.1%.
              Then used Open-CV to detect the face in an image and then pass the face to the classifer to predict the emotion of a person."
              link="https://github.com/soumyajit4419/Face_And_Emotion_Detection"
            />
          </Col>
        </Row>
      </Container>
    </Container>
  );
}

export default Projects;
